import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Projects from "./components/Projects";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";


function App() {
  const [dark, setDark] = useState(true);
  return (
    // <div className={dark ? "app_dark" : "app"}>
    <div className="app">
      <Navbar dark={dark} setDark={setDark} />
      <main>
        <Hero />
        <Projects />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
